import React from 'react';
import { connect } from 'react-redux';

import { Typography } from '@americanexpress/aqx-components';

import { makeGetAnnualFee, makeGetAnnualFeeDisclaimer } from '../redux';

import styles from '../__styles__/annualFee.scss?modules';

const AnnualFee = ({ annualFee, annualFeeDisclaimer }) => {
  return (
    <div className={styles.container}>
      <Typography $size={16} $lineHeight={24} className={styles.annualFee}>
        {annualFee}
      </Typography>
      {annualFeeDisclaimer && (
        <Typography
          $size={11}
          $lineHeight={24}
          className={styles.annualFeeDisclaimer}
        >
          {annualFeeDisclaimer}
        </Typography>
      )}
    </div>
  );
};

const mapStateToProps = () => {
  const getAnnualFee = makeGetAnnualFee();
  const getAnnualFeeDisclaimer = makeGetAnnualFeeDisclaimer();

  return (state, { shortName }) => ({
    annualFee: getAnnualFee(state, shortName),
    annualFeeDisclaimer: getAnnualFeeDisclaimer(state, shortName)
  });
};

export default connect(mapStateToProps)(AnnualFee);
